module.exports = __webpack_public_path__ + "static/media/smartid.cc8d4577.png";